import * as React from "react"
import "./styles.scss";
import ProductAccordionItem from "./ProductAccordionItem";

export default function ProductAccordion({data}) {

    return (
        <div className={`product-accordion`}> {data.map((item, index) => (
                <ProductAccordionItem key={`accordion-item-${index}`} itemData={item}
                                      index={index}></ProductAccordionItem>
            )
        )}
        </div>

    )
}
